
import { useNavigate } from 'react-router-dom';
import { Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { AlertScreen } from '../../components/AlertScreen'
import { envVariables } from '../../../../helpers';
import dayjs from 'dayjs';
import { TooltipAndIcon } from '../../components/TooltipAndIcon';

const paginado = Number(envVariables.REACT_APP_PAGINADO);





export const TablaCategorias = ({ data, chagePage, page }) => {

    const navigate = useNavigate();
    const totalBodega = 50;


    const handleInfoEditar = async(id) => {
        navigate(`/admin/add/${id}/categoria`);
    }



    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt:2 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'25%'}}>CREADA</TableCell>
                                <TableCell sx={{width:'50%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'%'}}>OPCIONES</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map( (uni) => (
                            <TableRow key={ uni.id }>
                                <TableCell>{ dayjs(uni.createdAt).format('DD/MMMM/YYYY').toUpperCase() }</TableCell>   
                                <TableCell>{ uni.nombre }</TableCell>
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo='Editar Categoria'
                                        icono='setting'
                                        onClick={ () => handleInfoEditar(uni.id) }
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalBodega / paginado)} disabled={Math.ceil(totalBodega / paginado) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay categorias por el momento..."/>
        }
        </>
    )
}
